import {Filters} from '../../constants/filter/filters';
import {CatalogFilterOptionsStoreClass} from './base';
import Dispatcher from "../../dispatcher";

export class WheelCatalogFilterOptionsStoreClass extends CatalogFilterOptionsStoreClass {
    getInitialState() {
        const filterOptions = [
            Filters.MANUFACTURER,
            Filters.WHEEL_MODEL,
            Filters.WHEEL_DIAMETER,
            Filters.WHEEL_WIDTH,
            Filters.WHEEL_STUDS,
            Filters.WHEEL_PCD,
            Filters.WHEEL_FINISH,
            Filters.PRICE_MIN,
            Filters.PRICE_MAX,
        ];
        return super.initFilterOptions(filterOptions);
    }
}

const WheelCatalogFilterOptionsStore = new WheelCatalogFilterOptionsStoreClass(Dispatcher);
export default WheelCatalogFilterOptionsStore;